import { Typography } from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ErrorIcon from '@material-ui/icons/Error'
import WarningIcon from '@material-ui/icons/Warning'

import { getTranslate } from '../../localization'
import { HealthStatus } from '../../types/channelPush'
import useStyles from './styles/statusBox.styles'

interface StatusBoxProps {
  status: HealthStatus
}

const StatusBox: React.FC<StatusBoxProps> = ({ status }) => {
  const classes = useStyles()
  const getColorForStatus = (s: HealthStatus) => {
    switch (s) {
      case 'Critical':
        return 'red'
        break

      case 'Normal':
        return 'green'
        break

      case 'Warning':
        return 'yellow'
        break

      default:
        break
    }
  }
  return (
    <div className={classes.root}>
      {getColorForStatus(status) === 'red' ? (
        <Typography
          variant="body1"
          className={[classes.text, classes.red].join(' ')}>
          <span>{getTranslate(status)}</span>
          <ErrorIcon />
        </Typography>
      ) : null}

      {getColorForStatus(status) === 'green' ? (
        <Typography
          variant="body1"
          className={[classes.text, classes.green].join(' ')}>
          <span>{getTranslate(status)}</span>
          <CheckCircleIcon />
        </Typography>
      ) : null}

      {getColorForStatus(status) === 'yellow' ? (
        <Typography
          variant="body1"
          className={[classes.text, classes.yellow].join(' ')}>
          <span>{getTranslate(status)}</span>
          <WarningIcon />
        </Typography>
      ) : null}
    </div>
  )
}

export default StatusBox
